// import * as dotenv from 'dotenv'
// dotenv.config().parsed
import { defineAsyncComponent, markRaw } from 'vue'
import { REDIRECT_AFTER_AUTH } from 'src/common/utils/redirect-after-auth'

export const CONFIG = {
  DEFAULT_GROUP: 'slot',
  SPEC_USER_DEFAULT_GROUP: 'hot',
  collapseStart: 300,
  COOKIES_OPTIONS: { path: '/' },
  COOKIES_OPTIONS_REMOVE: { path: '/' },
  SCROLL_ARROW: {
    RATIO: 1.5, // SCREEN SIZE * RATIO == SHOW BUTTON
  },
  API: {
    WS_TIMEOUT: 2000,
    TIMEOUT: 30000,
    API_BK_URL: process.env.API_BK_URL,
  },
  WS: {
    WS_INTERVAL_RECONNECT: 3000,
    PONG_TIMEOUT: 5000,
    PONG_INTERVAL: 20000,
  },
}

export const BASE_URL = process.env.BASE_URL || ''

const configuredLangList = process.env.LOCALES?.split('|').filter(Boolean) || []
const defaultLangList = ['ru', 'en', 'kk', 'az', 'uk', 'uz', 'ky', 'tr', 'hi', 'es']

export const AVAILABLE_LANG_LIST = configuredLangList.length ? configuredLangList : defaultLangList

export const AVAILABLE_CURRENCIES_LIST = [
  'TRY',
  'AZN',
  'JPY',
  'BTC',
  'RUB',
  'UZS',
  'THB',
  'KZT',
  'KGS',
  'UAH',
  'USD',
  'GEL',
  'INR',
  'ZAR',
  'EUR',
  'BRL',
  'BDT',
  'VIRT',
  'CNY',
  'BYN',
  'MDL',
  'GBP',
  'TJS',
  'ARS',
  'COP',
]

export const minBalanceForModalOnGame = {
  KZT: 30,
  UZS: 700,
  EUR: 0.1,
  USD: 0.1,
  GBP: 0.1,
  KGS: 5,
  RUB: 5,
  INR: 5,
  UAH: 3,
  AZN: 0.2,
  BDT: 10,
  TRY: 3,
}

export const HIDE_APPS_LINKS_BY_PLATFORM = new Set(['sultan'])
export const HIDE_SOCIAL_LINKS_BY_PLATFORM = new Set(['sultan'])

export const EVOLUTION_LIMITS_GROUPS = ['online']

// По какой-то причине если написать этот импорт в самом компоненте, то он закэшируется и не будет работать hot reload
export const getBonusModal = () => {
  return markRaw(defineAsyncComponent(() => import('components/modals/GetBonusModal.vue')))
}

export const getActivateBonusModal = () => {
  return markRaw(defineAsyncComponent(() => import('components/modals/ActivateBonusModal.vue')))
}

export const LOCATIONS_LIST = {
  ru: 'ru',
  en: 'en',
  bn: 'bn',
  uz: 'uz',
  ...(AVAILABLE_LANG_LIST.includes('uz-Cyrl') ? { 'uz-Cyrl': 'uz-Cyrl' } : {}),
  ky: 'ky',
  kk: 'kk',
  hi: 'hi',
}

export const LINK_INSIDE_PAYMENT_IDS = [272, 270, 269, 268, 267, 266]

export const ALLOW_MIRROR = {
  query: 'almirr',
  header: 'ALLOW-MIRROR',
  storage: localStorage,
}

export const ABTEST = {
  query: 'abtest',
  storage: localStorage,
}

export function isAbtestEnabled() {
  try {
    const value = ABTEST.storage.getItem(ABTEST.query)
    return value !== '0' && value !== 'false'
  } catch {
    return true
  }
}

export const LIST_OF_GET_PARAMS_TO_SAVE = {
  [ALLOW_MIRROR.query]: ALLOW_MIRROR.storage,
  [ABTEST.query]: ABTEST.storage,
  [REDIRECT_AFTER_AUTH.query]: REDIRECT_AFTER_AUTH.storage,
}

export const LIST_OF_GET_PARAMS_TO_CLEAR = [ALLOW_MIRROR.query, ABTEST.query]

export const showBkBalance = process.env.PLATFORM === 'olimp' && !process.env.OWN_SPORT

export const OPEN_GAMES_IN_IFRAME_FOR_USERS = ['3295809']

export const SERVER_NOT_RESPONSE = 'server_not_response'

export const ALLOWED_GROUPS_TOP_WINS = ['FAST', 'LOTTERY', 'ONLINE', 'SLOT', 'TABLE', 'VSPORT']
